"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const objectKeysBuilder = () => ({ entryVars: { object, }, }) => {
    if (typeof object !== 'object' || !object) {
        return [];
    }
    return Object.keys(object);
};
exports.default = objectKeysBuilder;
